import Env from "../base/env";
import Component from "gia/Component";
import gsap from "gsap";
import { ScrollToPlugin } from "../vendor/gsap-bonus-umd/ScrollToPlugin";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);
import Channels from "../base/channels";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    if (Env.mobileCSS) return false;
    this.DOM = {};
    this.DOM.view = this.element;
    //!
    this.VARS = {
      EASE: {
        TYPE: "cubic.inOut",
        DURATION: 0.8,
      },
    };
    this.events();
    this.listen();
  }

  events() {
    if (typeof this.ref.restartSlideshow != "undefined") {
      for (let btn of this.ref.restartSlideshow) {
        btn.addEventListener("click", () => {
          gsap.to(window, {
            scrollTo: 0,
            ease: "cubic.out",
            duration: 0.3,
            delay: 0.2,
          });
        });
      }
    }
  }

  listen() {
    this.stListen = ScrollTrigger.create({
      trigger: this.DOM.view,
      start: "top -200px",
      onLeaveBack: () => {
        Channels.emit("accordions::close");
      },
    });
  }

  unmount() {}
}
